import { Box, Tab, Tabs } from '@mui/material'
import { TabPanel } from 'Common/Supplyvue-ui'
import { ReactNode, useState } from 'react'

type ChartViewProps = {
  SequencedGraphView: ReactNode
  TotalledGraphView: ReactNode
}

export const ChartView = ({
  SequencedGraphView,
  TotalledGraphView,
}: ChartViewProps) => {
  const TABS = {
    SEQUENCED_TAB: 'tab-0',
    TOTALLED_TAB: 'tab-1',
  }
  const [selectedTab, setSelectedTab] = useState(TABS.SEQUENCED_TAB)

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{ height: '100%', width: '100%', minWidth: 850 }}
    >
      <Tabs
        value={selectedTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={(_event, newValue) => setSelectedTab(newValue)}
        sx={{ borderBottom: '1px solid lightgray' }}
      >
        <Tab label="Sequenced" value={TABS.SEQUENCED_TAB} />
        <Tab label="Totalled" value={TABS.TOTALLED_TAB} />
      </Tabs>
      <TabPanel index={TABS.SEQUENCED_TAB} value={selectedTab}>
        {SequencedGraphView}
      </TabPanel>
      <TabPanel index={TABS.TOTALLED_TAB} value={selectedTab}>
        {TotalledGraphView}
      </TabPanel>
    </Box>
  )
}
